<script lang="ts">
    export let height = "h-6";
    export let width = "w-6";
    export let strokeColor = "stroke-white";
    export let fillColor = "fill-transparent";
    export let classList = "aspect-ratio transition-all";
</script>

<svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    class="icon icon-tabler icons-tabler-outline icon-tabler-arrow-bar-right {height} {width} {strokeColor} {fillColor} {classList}"
>
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M20 12l-10 0" />
    <path d="M20 12l-4 4" />
    <path d="M20 12l-4 -4" />
    <path d="M4 4l0 16" />
</svg>
